<template>
  <div class="index">
    <div class="home_tit">
      <div class="home_tit_top" style="background: var(--bg-color)">
        <div class="home_tit_middle" @click="goTo(112)">
          <img src="../../assets/images/4-002.png" alt="" />
          <span style="color: #fff; margin-left: 5px">
            {{ $t("m.sy_span0") }}</span
          >
        </div>
        <div class="home_tit_right">
          <img
            @click="goTo(12)"
            src="../../assets/images/new/icon1.png"
            style="margin-right: 10px"
          />
        </div>
      </div>
    </div>

    <div style="margin-top: 50px; padding: 0 15px; background: var(--bg-color)">
      <div
        style="
          white-space: nowrap;
          width: 100%;
          height: 80px;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
        "
      >
        <div
          v-for="(item, index) in blocks"
          @click="goTo(item.id)"
          :key="item.id"
          style="
            margin-right: 0px;
            text-align: center;
            border-radius: 6px;
            margin-top: 10px;
            position: relative;
            color: #333;
          "
        >
          <div class="home_block_list_img"><img :src="item.img" /></div>
          <p class="ppp">{{ $t("m.sy_list1")[index] }}</p>
        </div>
      </div>
    </div>
    <div style="padding: 0 10px">
      <div
        style="
          margin-top: 0px;
          background: #fff;
          border-radius: 0 0 10px 10px;
          overflow: hidden;
        "
      >
        <div class="home_msg" style="height: 50px">
          <img
            style="width: 15px; height: 15px"
            src="../../assets/images/new/laba.png"
          />
          <div class="home_msg_con">
            <div
              style="height: 30px"
              v-for="(item, index) in gglist"
              :key="index"
              @click="dianjilb(item.id)"
            >
              <div
                style="
                  height: 30px;
                  line-height: 30px;
                  display: flex;
                  align-items: center;
                "
              >
                <div
                  class="zuoce"
                  style="color: #333; font-size: 13px; flex: 1"
                >
                  {{ item.title }}
                </div>
                <span
                  style="
                    text-align: right;
                    width: 40px;
                    font-size: 11px;
                    color: #666;
                    margin-left: 5px;
                  "
                  >{{ createDate(item.created_at) }}</span
                >
                <img
                  src="../../assets/images/licai/right.png"
                  style="width: 12px; height: 12px; margin-left: 5px"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="border-radius: 10px; padding: 0 10px; overflow: hidden">
      <img
        @click="quhuzhuan()"
        src="../../assets/images/new/zijinback.jpg"
        style="border-radius: 10px; width: 100%; height: auto; float: left"
        alt=""
      />
    </div>
    <div style="padding: 0 10px">
      <div
        class="home_block am-cf"
        style="background: #fff; border-radius: 10px"
      >
        <div
          class="home_block_list am-fl"
          style="width: 20%"
          v-for="(item, index) in blocks1"
          @click="goTo(item.id)"
          :key="item.id"
        >
          <div class="home_block_list_img" style="width: 35px; height: 35px">
            <img :src="item.img" />
          </div>
          <p style="font-size: 12px; color: #333">
            {{ $t("m.sy_list2")[index] }}
          </p>
        </div>
      </div>
    </div>

    <!--积分商城-->

    <div style="padding: 15px 10px 1px">
      <div style="display: flex; margin-bottom: 15px">
        <h3 style="font-size: 16px; width: 85%; font-weight: 500">积分商城</h3>
        <div style="width: 15%" @click="wayToArticle">
          <span
            style="
              font-size: 13px;
              color: rgb(102, 102, 102);
              margin-left: 5px;
              vertical-align: middle;
            "
            >更多
          </span>
          <img
            src="@/assets/images/home/more.png"
            style="
              width: 13px;
              height: 13px;
              margin-left: 5px;
              vertical-align: middle;
            "
          />
        </div>
      </div>
      <div class="goods-box">
        <div
          class="goods-list"
          v-for="item in goodsList"
          :key="item.id"
          @click="wayToLink(item.id)"
        >
          <img class="goods-img" :src="item.images" alt="" />
          <div class="goods-title el-h-1">{{ item.title }}</div>
          <div class="goods-price el-h-1">{{ item.price }}</div>
        </div>
      </div>
    </div>

    <div
      style="display: flex; padding: 0 10px; margin-top: 0px"
      v-if="category.length > 1"
    >
      <div
        style="
          white-space: nowrap;
          width: 100%;
          overflow: hidden;
          overflow: scroll;
          border-bottom: 0px solid #eee;
        "
        v-if="category[1].list.length > 0"
      >
        <div
          class="danshu"
          v-for="item in category[1].list.slice(0, 3)"
          :key="item.id"
          @click="details(item.id)"
        >
          <div
            v-if="item.status == 2"
            style="
              position: absolute;
              left: 0;
              top: 0px;
              width: 95%;
              height: 90%;
              display: flex;
              align-items: center;
              flex-direction: row-reverse;
              z-index: 100;
            "
          >
            <img
              src="../../assets/images/licai/wancheng.png"
              style="
                width: 60px;
                height: 60px;
                margin: 0px;
                position: relative;
                top: 40px;
              "
              alt=""
            />
          </div>
          <div
            style="
              font-size: 14px;
              font-weight: 500;
              color: #333;
              padding: 0 0px;
              margin-top: 5px;
              display: flex;
              align-items: center;
            "
          >
            <div class="line-clamp1" style="flex: 1">
              {{ item.tag }}：{{ item.title }}
            </div>
            <p
              class="productSort_block_left_dm"
              style="
                border: 1px solid var(--bg-color);
                color: var(--bg-color);
                padding: 1px 5px;
                border-radius: 2px;
                margin-left: 10px;
                font-size: 10px;
                border-radius: 3px;
              "
            >
              {{ item.additional == 1 ? $t("m.shouyiguo") : $t("m.changgui") }}
            </p>
            <img
              v-if="item.clock == 1"
              src="../../assets/images/licai/naozhong.png"
              style="width: 25px; height: 25px; margin-left: 15px"
              alt=""
            />
            <img
              v-if="item.additional == 1"
              src="../../assets/images/licai/shouyi.png"
              style="width: 25px; height: 25px; margin-left: 15px"
              alt=""
            />
          </div>

          <div
            style="
              border-radius: 6px;
              display: flex;
              align-items: center;
              height: 70px;
              padding-top: 10px;
              justify-content: space-between;
            "
          >
            <div style="text-align: center">
              <div
                style="
                  font-size: 24px;
                  color: var(--bg-color);
                  font-weight: bold;
                  line-height: 25px;
                "
              >
                {{ item.rate }}
                <span style="font-size: 13px">%</span>
              </div>
              <div style="font-size: 12px; color: #666; margin-top: 3px">
                {{ $t("m.rishouyi") }}
              </div>
            </div>
            <div style="text-align: left">
              <div
                style="
                  font-size: 22px;
                  color: #000;
                  font-weight: bold;
                  line-height: 25px;
                "
              >
                {{ item.day }}
                <span style="font-size: 13px">{{ $t("m.day") }}</span>
              </div>
              <div style="font-size: 12px; color: #666; margin-top: 3px">
                {{ item.min }}{{ $t("m.qitou") }}
              </div>
            </div>
            <div>
              <div
                :style="{
                  background: item.status == 2 ? '#dfdfdf' : 'var(--bg-color)'
                }"
                style="
                  text-align: center;
                  width: 75px;
                  line-height: 25px;
                  border-radius: 6px;
                  background: var(--bg-color);
                  color: #fff;
                  font-size: 13px;
                  font-weight: bold;
                  margin-top: 0px;
                "
              >
                {{ $t("m.mairu") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 15px 10px 1px">
      <div style="display: flex; margin-bottom: 15px">
        <h3 style="font-size: 16px; width: 85%; font-weight: 500">最新资讯</h3>
        <div style="width: 15%" @click="wayToArticle">
          <span
            style="
              font-size: 13px;
              color: rgb(102, 102, 102);
              margin-left: 5px;
              vertical-align: middle;
            "
            >更多
          </span>
          <img
            src="@/assets/images/home/more.png"
            style="
              width: 13px;
              height: 13px;
              margin-left: 5px;
              vertical-align: middle;
            "
          />
        </div>
      </div>
      <div
        style="margin-bottom: 15px; border-bottom: 1px solid #eee"
        v-for="(item, index) in newsList"
        :key="index"
        @click="
          $router.push({ name: 'article_detail', query: { id: item.id } })
        "
      >
        <div style="display: flex; align-items: center">
          <img
            :src="item.image"
            style="border-radius: 6px; width: 130px; height: 73px"
            alt=""
          />
          <div style="flex: 1; margin-left: 10px">
            <div
              class="line-clamp2"
              style="
                font-size: 14px;
                height: 50px;
                line-height: 25px;
                color: #000;
                font-weight: bold;
              "
            >
              {{ item.title }}
            </div>

            <!--            <div-->
            <!--              style="-->
            <!--                display: flex;-->
            <!--                align-items: center;-->
            <!--                color: #666;-->
            <!--                font-size: 10px;-->
            <!--              "-->
            <!--            >-->
            <!--              <span style="margin-right: 25px">{{ $t("m.fx_span3") }}</span>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div
      style="z-index: 1000"
      v-if="yaoqi && detailData"
      class="mask"
      @click="yaoqi1"
    >
      <div style="position: relative">
        <div
          class="mask-modal modaltwo"
          style="
            width: 300px;
            height: 450px;
            background: linear-gradient(to bottom, #ffc97e, #ffc97e, #ff4600);
            padding: 15px;
            padding-top: 20px;
            padding-bottom: 20px;
          "
        >
          <div style="height: 370px; background: #fff; overflow-y: scroll">
            <div
              v-html="detailData.content"
              class="content"
              style="height: 400px"
            ></div>
          </div>
          <div
            @click="yaoqi1"
            style="
              left: 20px;
              right: 20px;
              position: absolute;
              bottom: 15px;
              margin: 0 auto;
              text-align: center;
              line-height: 40px;
              border-radius: 30px;
              color: #a56400;
              background: linear-gradient(to bottom, #f7e2bf, #ffcd7c);
              font-size: 14px;
              font-weight: bold;
            "
          >
            我已了解
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Socket from "@libs/chat";
import $store from "../../store";
import request from "@utils/request";
import "@assets/css/swiper.min.css";
import { getCategory } from "@api/store";

var vm = null;
export default {
  name: "Index",
  props: {},
  components: {},
  data: function() {
    return {
      maichubi: 63.47,
      mairubi: 36.53,
      maichubi1: 64.01,
      mairubi1: 35.99,
      mytime: "",
      socket: null,
      detailData: null,
      yaoqi: true,
      curStartTime: "2019-07-31 08:00:00",
      laitime: "",
      day: "0",
      hour: "00",
      min: "00",
      second: "00",
      jinyinIndex: 0,
      jinyin: {
        jin: 1.0004,
        type1: true,
        fudu1: "+0.0002",
        min1: "1.0000",
        max1: 1.0004,
        bfb1: "-0.0001%",
        yin: 6.35,
        type2: false,
        fudu2: -0.06,
        bfb2: "-0.07%",
        xin: 6.34,
        type3: true,
        fudu3: +0.03,
        bfb3: "+0.04%"
      },
      selects: 0,
      reRender: true,
      show: false,
      types: 0,
      token: "",
      swiperOption: {
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination"
        },
        on: {
          click: function() {
            const realIndex = this.realIndex;
            vm.dianjilb(realIndex);
          }
        }
      },
      image:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F015ef657bc11150000012e7eafa2e0.png%402o.png&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1634556413&t=2fb650f58dfd37bf68e8ffd138c2dc73",
      blocks1: [
        {
          id: 0,
          img: require("@/assets/images/home/home6.png"),
          title: "每日签到"
        },
        {
          id: 5,
          img: require("@/assets/images/home/home7.png"),
          title: "会员等级"
        },

        {
          id: 4,
          img: require("@/assets/images/home/home8.png"),
          title: "实名认证"
        },
        {
          id: 6,
          img: require("@/assets/images/home/home9.png"),
          title: "我的团队"
        },
        {
          id: 8,
          img: require("@/assets/images/home/home10.png"),
          title: "安全保障"
        },
        {
          id: 9,
          img: require("@/assets/images/home/home11.png"),
          title: "幸运抽奖"
        },
        {
          id: 1001,
          img: require("@/assets/images/home/home12.png"),
          title: "积分商城"
        },
        {
          id: 1002,
          img: require("@/assets/images/home/home13.png"),
          title: "日利宝"
        },
        {
          id: 1003,
          img: require("@/assets/images/home/home14.png"),
          title: "我的资产"
        },
        {
          id: 1004,
          img: require("@/assets/images/home/home15.png"),
          title: "我的投资"
        }
      ],
      blocks: [
        {
          id: 1,
          img: require("@/assets/images/home/home1.png"),
          title: "我要充值"
        },
        {
          id: 2,
          img: require("@/assets/images/home/home2.png"),
          title: "我要提现"
        },
        {
          id: 7,
          img: require("@/assets/images/home/home3.png"),
          title: "公司资质"
        },
        {
          id: 45,
          img: require("@/assets/images/home/home4.png"),
          title: "邀请好友"
        },
        {
          id: 3,
          img: require("@/assets/images/home/home5.png"),
          title: "每日签到"
        }
      ],
      // 资讯
      newsList: [],
      category: [],
      // 商品参数
      products: [],
      gglist: [],
      id: "ceshi",
      goodsList: []
    };
  },
  beforeDestroy() {
    this.socket && this.socket.close();
  },
  created() {
    vm = this;
    this.token = $store.state.app.token;
    let yy = localStorage.getItem("lang");
    if (yy) {
      if (yy == "en-US") {
        this.$i18n.locale = "en-US";
      } else {
        this.$i18n.locale = "zh-CN";
      }
    }
  },
  activated() {
    this.reRender = false;
    setTimeout(() => {
      this.reRender = true;
    }, 10);
  },
  mounted: function() {
    this.detime();
    this.detime1();
    this.socket = new Socket();
    this.socket.vm(this);

    this.$on("onMessage", data => {
      this.jinyinIndex = 1;
      if (data.length > 50) {
        // console.log("数组数据：");
        // console.log(JSON.parse(data[0]));
      }
      if (data.code) {
        if (data.code == "0" && data.data.length > 0) {
          if (data.data[0].usdCny) {
            let cny = data.data[0].usdCny;
            let cce = (cny * this.jinyin.jin).toFixed(2);
            if (this.jinyin.yin <= cce) {
              this.jinyin.type2 = true;
            } else {
              this.jinyin.type2 = false;
            }
            if (this.jinyin.xin <= cny) {
              this.jinyin.type3 = true;
            } else {
              this.jinyin.type3 = false;
            }
            this.jinyin.yin = cce;
            this.jinyin.xin = cny;
          }
        }
      }
      if (data.arg) {
        if (data.arg.channel == "tickers" && data.arg.instId == "USDT-USDK") {
          if (data.data.length > 0) {
            if (this.jinyin.jin <= data.data[0].last) {
              this.jinyin.type1 = true;
            } else {
              this.jinyin.type1 = false;
            }
            this.jinyin.jin = data.data[0].last; //最新价
            this.jinyin.max1 = data.data[0].high24h; //最高价
            this.jinyin.min1 = data.data[0].low24h; //最低价
            let kai = data.data[0].open24h; //开盘价
            let mairu = parseFloat(data.data[0].bidSz); //左边买入量
            let mairu1 = parseFloat(data.data[0].bidSz) - 30000; //右边买入量1
            let maichu = parseFloat(data.data[0].askSz); //左边卖出量
            let maichu1 = parseFloat(data.data[0].askSz) - 30000; //右边卖出量1
            let mairubi = ((mairu / (mairu + maichu)) * 100).toFixed(2); //左边买入比例
            let maichubi = (100 - mairubi).toFixed(2); //左边卖出比例
            this.mairubi = mairubi;
            this.maichubi = maichubi;

            let mairubi1 = ((mairu1 / (mairu1 + maichu1)) * 100).toFixed(2); //右边买入比例
            let maichubi1 = (100 - mairubi1).toFixed(2); //右边卖出比例
            this.mairubi1 = mairubi1;
            this.maichubi1 = maichubi1;
            let cha = (this.jinyin.jin - kai).toFixed(4);
            if (cha >= 0) {
              this.jinyin.fudu1 = "+" + cha;
              this.jinyin.bfb1 = "+" + (cha / kai).toFixed(4) + "%";
            } else {
              this.jinyin.fudu1 = cha;
              this.jinyin.bfb1 = (cha / kai).toFixed(4) + "%";
            }

            let cce = (this.jinyin.yin * this.jinyin.jin).toFixed(2);
            if (this.jinyin.yin <= cce) {
              this.jinyin.type2 = true;
            } else {
              this.jinyin.type2 = false;
            }
            this.jinyin.yin = cce;
          }
        }
      }

      let huilv = this.jinyin.jin * this.jinyin.yin;
      let ss = $store.state.app.huilv;
      if (huilv >= ss) {
        this.shangxia = true;
      } else {
        this.shangxia = false;
      }
      this.$store.commit("HUILV", huilv);
    });
    this.$on("socket_error", () => {
      // this.$dialog.error("连接失败");
    });
    this.$on("err_tip", data => {
      // this.$dialog.error(data.msg);
    });
    this.$on("socket_open", () => {
      // this.$dialog.error("连接成功");
    });
    this.curStartTime = "2022-02-09";
    this.countTime();
    let that = this;
    request
      .post(
        "/api/v1/article/article/list",
        {
          cid: 15,
          page: 1
        },
        {
          login: false
        }
      )
      .then(res => {
        let gglist1 = res.data.data;
        if (gglist1.length > 0) {
          that.detailData = gglist1[0];
        }
      });
    this.$nextTick(function() {
      getCategory().then(res => {
        let list = [];
        for (let i = 0; i < res.data.data.length; i++) {
          if (i < 4) {
            list.push(res.data.data[i]);
          }
        }
        // 保留两个产品。
        for (let j = 0; j < list.length; j++) {
          if (list[j].list.length > 2) {
            list[j].list.splice(2, list.length + 1);
          }
        }
        this.category = list;
      });
      request
        .post(
          "/api/v1/article/article/list",
          {
            cid: 7,
            page: 1
          },
          {
            login: false
          }
        )
        .then(res => {
          this.gglist = res.data.data;
          let val = Math.max(...this.gglist.map(a => a.sort));
          let saa = [];
          for (let index = 0; index < this.gglist.length; index++) {
            const dic = this.gglist[index];
            if (dic.sort == val) {
              saa.push(dic);
            }
          }
          this.gglist = saa;
        });
    });
    // 活动列表
    request
      .post(
        "/api/v1/article/cat/all",
        {},
        {
          login: false
        }
      )
      .then(res => {
        this.newsList = res.data.data[0].list;
      });
    // 商品
    this.wayGoods();
  },
  computed: {
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return h + ":" + m;
      };
    }
  },
  methods: {
    // 积分商城
    wayToLink(id) {
      this.$router.push({ path: "/JfContent/" + id });
    },
    // 积分列表
    wayGoods() {
      request.post("/api/v1/index/goods", {}).then(response => {
        this.goodsList = response.data.data;
      });
    },
    wayToArticle() {
      this.$router.push({ path: "/article" });
    },
    quhuzhuan() {
      this.$router.push({
        path: "/yuezhuan"
      });
    },
    detime() {
      let date = new Date();
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      this.mytime = MM + "月" + d + "日" + h + "时" + m + "分" + s + "秒 ";
    },
    detime1() {
      let date = new Date();
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      this.laitime = y + "-" + MM + "-" + d + " " + h + ":" + m;
    },
    yaoqi1() {
      this.yaoqi = false;
    },
    // 倒计时
    countTime() {
      // 获取当前时间
      let date = new Date();
      let now = date.getTime();
      // 设置截止时间
      let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
      let end = endDate.getTime();
      // 时间差
      let leftTime = end - now;
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        // 时
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.hour = h < 10 ? "0" + h : h;
        // 分
        let m = Math.floor((leftTime / 1000 / 60) % 60);
        this.min = m < 10 ? "0" + m : m;
        // 秒
        let s = Math.floor((leftTime / 1000) % 60);
        this.second = s < 10 ? "0" + s : s;
      } else {
        this.day = 0;
        this.hour = "00";
        this.min = "00";
        this.second = "00";
      }
      // 等于0的时候不调用
      if (
        Number(this.hour) === 0 &&
        Number(this.day) === 0 &&
        Number(this.min) === 0 &&
        Number(this.second) === 0
      ) {
        return;
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        setTimeout(this.countTime, 1000);
      }
    },
    dianji(e) {
      this.selects = e;
    },
    dianjilb(index) {
      this.$router.push({
        name: "article_detail",
        query: {
          id: index
        }
      });
    },
    details: function(id) {
      this.$router.push({
        path: "/detail/" + id
      });
    },
    goTo: function(url) {
      switch (url) {
        case "user":
          this.$router.push({
            path: "/user"
          });
          break;
        case 11:
          this.$router.push({
            path: "/JfList"
          });
          break;
        case 12:
          this.$router.push({
            path: "/my-assets"
          });
          break;
        case 211:
          this.$router.push({
            path: "/language"
          });
          break;
      }

      if (url == 0) {
        // 充值
        this.$router.push({
          path: "/Signln"
        });
      }
      if (url == 1) {
        // 充值
        this.$router.push({
          path: "/CzContent"
        });
      }
      if (url == 2) {
        // 提现
        this.$router.push({
          path: "/txCash"
        });
      }
      if (url == 3) {
        // 邀请好友
        this.$router.push({
          path: "/invitation"
        });
      }
      if (url == 4) {
        // 实名认证
        this.$router.push({
          path: "/memmber_business"
        });
      }
      if (url == 5) {
        //会员等级
        this.$router.push({
          path: "/Grade"
        });
      }
      if (url == 6) {
        //我的团队
        this.$router.push({
          path: "/team"
        });
      }
      if (url == 1001) {
        //我的团队
        this.$router.push({
          path: "/JfList"
        });
      }
      if (url == 1002) {
        //我的团队
        this.$router.push({
          path: "/rilibaoindex"
        });
      }
      if (url == 1003) {
        //我的团队
        this.$router.push({
          path: "/moneyDetail"
        });
      }
      if (url == 1004) {
        //我的团队
        this.$router.push({
          path: "/myInvest"
        });
      }
      if (url == 7) {
        //平台介绍
        this.$router.push({
          name: "GoodsClass"
          // query: {
          // 	id: 18
          // }
        });
      }
      if (url == 45) {
        //平台介绍
        this.$router.push({
          name: "article_detail",
          query: {
            id: 18
          }
        });
      }
      if (url == 77) {
        //平台介绍
        this.$router.push({
          name: "article_detail",
          query: {
            id: 17
          }
        });
      }
      if (url == 8) {
        //安全保障
        this.$router.push({
          name: "article_detail",
          query: {
            id: 51
          }
        });
      }
      if (url == 9) {
        this.$router.push({
          // path: "/customerService"
          path: "/user/zhuanpan"
        });
      }
      if (url == 10) {
        //客户中心
        this.$router.push({
          path: "/user"
        });
      }
      if (url == 111) {
        //客户中心
        this.$router.push({
          path: "/article"
        });
      }
      if (url == 112) {
        //客户中心
        this.$router.push({
          path: "/qiehuan"
        });
      }
    }
  }
};
</script>
<style scoped lang="less">
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.mask-modal {
  border-radius: 5px;
}

/deep/ .van-circle__text {
  color: #777;
  font-size: 12px;
}

/deep/ .listname:last-child {
  margin-right: 0 !important;
}

/deep/ .swiper-pagination-bullet {
  border: 2px solid #fff;
  background: #dfdfdf;
}

/deep/ .swiper-pagination-bullet-active {
  // 这以下的代码是你需要的
  background: #fff;
  border: 0px solid #fff;
}

.danshu {
  width: 90%;
  display: inline-block;
  margin-right: 10px;
  padding: 20px 15px 20px 15px;
  border-radius: 10px;
  position: relative;
  border: 0px solid #fff;
  background-size: 100% 100%;
  background-color: #e8e8e8;
}

.line-clamp2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.line-clamp1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.home_vip_block {
  border-right: 1px solid #eceeed;
  width: 50%;
  padding: 20px 0px;
}

.home_vip_block:last-child {
  border: 0px;
}

.home_tab_item {
  padding: 0px 0px;
}

.home_con_block {
  padding: 0px 15px;
  margin-top: 15px;
}

.home_con_text {
  width: 100%;
}

.home_con_list {
  margin-top: 10px;
}

.home_con_list_block {
  width: 50%;
}

.home_con_block img {
  width: 100%;
  height: 110px;
}

.name {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000;
}

.names {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #666;
  margin-left: 3%;
  padding: 3px 5px;
}

.trip {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #d3d3d3;
}

.home_tab_item_block {
  margin-top: 10px;
  font-size: 14px;
  width: 25%;
  margin-left: 5%;
  text-align: center;
  padding-bottom: 5px;
}

/* .home_tab_item_block:first-child{margin-left: 0px;} */
.home_tab_item_blocks {
  color: #007aff;
  border-bottom: 3px solid #007aff;
  font-size: 14px;
}

.home_vip_block img {
  width: 27px;
  height: 29px;
  margin: 0 auto;
  display: block;
}

.home_vip_block p {
  text-align: center;
  font-size: 13px;
  color: #000000;
  margin-top: 8px;
}

.home_vip_block:last-child img {
  width: 40px;
  height: 27px;
  margin: 0 auto;
  display: block;
}

.home_line {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 15px;
}

.home_line img {
  border-radius: 5px;
  height: 98px;
  flex: 1;
  margin-right: 1.5%;
}

.home_line img:first-child {
  width: 43%;
}

.home_line img:last-child {
  margin-right: 0px;
}

.home_block {
  margin-top: 0px;
  // background: #fff;

  padding: 5px 0px;
  padding-bottom: 15px !important;
}

.home_block_list {
  width: 24%;
  margin-top: 15px;
}

.home_block_list p,
.ppp {
  text-align: center;
  font-size: 13px;
  font-family: Microsoft YaHei;
  //   font-weight: 600;
  color: #fff;
  margin-top: 6px;
}

.home_block_list_img {
  width: 30px;
  height: 30px;
  margin: 0 auto;
  display: block;
  margin-bottom: 8px;
}

.home_block_list_img img {
  width: 100%;
  height: 100%;
}

.home_msg_con {
  margin-left: 5px;
  flex: 1;
  font-size: 14px;
  line-height: 21px;
}

.home_msg img {
  width: auto;
  height: 14px;
}

.home_msg {
  // overflow: hidden;
  border-top: 1px solid #eee;
  //  background:  linear-gradient(to right,#fff,#FAF9EC);

  height: 60px;
  display: flex;
  align-items: center;
  margin: 0px 10px;
}

.home_tit {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
}

.home_tit_top {
  height: 50px;

  display: flex;
  align-items: center;
}

.home_swiper {
  width: 100%;
  height: 190px;
}

.home_swiper swiper-slide {
  width: 100%;
  height: 190px;
}

.home_swiper {
  height: 190px;
}

.banner_img {
  width: 100%;
  height: 190px;
}

.home_tit_left {
  width: 25%;
  display: flex;
  align-items: center;
}

.home_tit_left img {
  width: 23px;
  height: 23px;
}

.home_tit_left div {
  margin: 0 20px;
  color: #333;
  font-size: 16px;
}

.home_tit_middle {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  margin: 0 0px;
  color: #000;
  font-weight: bold;
  font-size: 18px;
}

.home_tit_middle img {
  width: 35px;
  height: 35px;
  margin-left: 6px;
}

.home_tit_middle {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  margin: 0 0px;
  color: #000;
  font-weight: bold;
  font-size: 18px;
}

.home_tit_right {
  padding-right: 10px;
  width: auto;
  min-width: 32px;
  display: flex;
  align-items: center;
  color: #333;
  flex-direction: row-reverse;

  font-size: 15px;
  font-weight: bold;
}

.home_tit_right img {
  width: 22px;
  height: 22px;
  margin-left: 7px;
}

[v-cloak] {
  display: none;
}

/* 清除浮动*/
.am-fl {
  float: left;
}

.am-fr {
  float: right;
}

.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.am-cf {
  zoom: 1;
}

.overflow1 {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.index {
  background-color: #fff;
  padding-bottom: 70px;
}

.index .follow {
  z-index: 100000;
}

.keep {
  text-align: center;
}

.productSort_block_left_xh {
  max-width: 220px;
  overflow: hidden;
  /*超出部分隐藏*/
  white-space: nowrap;
  /*禁止换行*/
  text-overflow: ellipsis;
  /*省略号*/
  margin-bottom: 5px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 36px;
}

.zuoce {
  // max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 13px;
  color: #666;
}

.zuoce1 {
  color: #666;
  font-size: 11px;
}

.productSort_block_left_dm {
  border: 1px solid #ffa68c;
  color: #ffa68c;
  padding: 2px 5px;
  border-radius: 2px;
  margin-left: 10px;
  font-size: 11px;
}

.productSort_block_last {
  padding: 0px 9px;
  align-items: center;
  display: flex;
}

.productSort_block_last_item:last-child {
  margin-left: 60px;
}

.productSort_block_left {
  display: flex;
  align-items: center;
  padding: 0 9px;
  margin-bottom: 6px;
  justify-content: space-between;
}

.productSort_con_list {
  padding: 10px 10px;

  border-radius: 10px;
}

.productSort_block {
  position: relative;

  width: 100%;
  background-color: #ffffff;
  padding: 10px 0px;
  margin-bottom: 10px;
}

.productSort_block img {
  width: 100%;
  height: 86px;
}

.productSort_top {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 0 6px;
  /* justify-content: space-between; */
}

.productSort_top_block {
  flex-shrink: 0;

  display: inline-block;
  margin-right: 14px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  text-align: center;
}

.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
}

.productSort_top_blocks {
  border-bottom: 2px solid #007aff;
  color: #007aff;
}

/deep/ .mask .content img {
  width: 100% !important;
}
// 商城
.goods-box {
  display: flex;
  margin: 10px 0px;
  background: rgb(255, 255, 255);
  padding: 10px 15px 2px 10px;
  border-radius: 10px;
  .goods-list {
    width: 23%;
    margin: 5px 1%;
  }
  .goods-img {
    width: 100%;
    border-radius: 6px;
  }
  .goods-title {
    font-size: 12px;
    font-weight: 600;
  }
  .goods-price {
    font-size: 13px;
    color: #0372fb;
  }
  .el-h-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
